import React, {RefObject, useRef} from 'react';
import cx from 'classnames';

import styles from '../Markdown.pcss';

const LINE_HEIGHT = 19.7;

const isRefElementMultiline = (ref: RefObject<HTMLElement>): boolean => {
    if (!ref.current || !!ref.current.children.length) return false;
    const height: number =
        ref.current.clientHeight || ref.current.getBoundingClientRect().height || 0;
    return height > LINE_HEIGHT;
};

const MarkdownListItem = (props: {
    checked?: boolean;
    tight: boolean;
    ordered: boolean;
    index: number;
    children: React.ReactNode;
}) => {
    const listItemRef: RefObject<HTMLElement> = useRef(null);

    const itemClassName = cx(styles.listItem, {
        [styles.isMultiLine]: isRefElementMultiline(listItemRef)
    });

    return (
        <li className={itemClassName}>
            <span className={styles.listItemContent} ref={listItemRef}>
                {props.children}
            </span>
        </li>
    );
};

export default MarkdownListItem;
